import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-company-list-item',
  templateUrl: './company-list-item.component.html',
  styleUrls: ['./company-list-item.component.scss']
})
export class CompanyListItemComponent implements OnInit,OnDestroy {
  @Input() company: any;
  @Input() isFullWidth: boolean= false;
  private destroy$ = new Subject<void>();
  color: string;
  initials: any;
  colors:any=['#ADD8E6','#FFB6C1','#E6E6FA','#FA8072','#ADD8E6','#D8BFD8','#B0E0E6','#E6E6FA','#ADD8E6','#FFB6C1'];
  constructor() { }

  ngOnInit(): void {
    this.company.logoPath == "https://3plbe.nineyard.com/" ? this.company.logoPath = null : this.company.logoPath;
    this.getRandomColor();  
    this.getInitials(this.company.companyName);  
  } 
  
  getInitials(nameString) {
    const fullName = nameString.split(' ');
    if(fullName.length >= 2){
      this.initials = fullName[0].slice(0, 1) + fullName[1].slice(0, 1);
    }else{
      this.initials = fullName[0].slice(0, 1);
    }   
  }

  getRandomColor() {
    var color = this.colors[Math.floor((Math.random() * 100) + 1) % 10];
    this.color = '#' + ('000000' + color).slice(-6);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
